import { CAPTURE_URL, PAY_URL } from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

export const createPaypalOrder = async (userInfo, partnerId, orderId) => {
    let plebicardUrl = `${PAY_URL}?email=${userInfo.email}`;
    plebicardUrl = userInfo.userId
        ? plebicardUrl.concat(`&userId=${userInfo.userId}`)
        : plebicardUrl;
    plebicardUrl = userInfo.clickId
        ? plebicardUrl.concat(`&clickId=${userInfo.clickId}`)
        : plebicardUrl;

    try {
        const response = await fetch(plebicardUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ ...userInfo, partnerId, orderId })
        });

        const res = await response.json();
        return res.payload.widgetLink;
    } catch (error) {
        console.error('Failed to create PayPal order :', error);
        throw error;
    }
};

export const capturePaypalOrder = async (paypalOrderId, userInfo, partnerId) => {
    let plebicardUrl = `${CAPTURE_URL}/${paypalOrderId}?email=${userInfo.email}`;
    plebicardUrl = userInfo.userId
        ? plebicardUrl.concat(`&userId=${userInfo.userId}`)
        : plebicardUrl;
    plebicardUrl = userInfo.clickId
        ? plebicardUrl.concat(`&clickId=${userInfo.clickId}`)
        : plebicardUrl;

    try {
        const response = await fetch(plebicardUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ ...userInfo, partnerId })
        });

        const res = await response.json();
        return { status: response.status, ...res };
    } catch (error) {
        console.error('Failed to confirm PayPal order :', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/paypal/utils.js